import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Text } from '@cubeyou-team/hx-react-components';

import translations from 'src/lang';
import { changeDataSourceRequest } from 'src/actions';
import { useQueryValidation } from '../../hooks/useQueryValidation';
import { QuerySource, ConfirmDataSourceChangeModal } from './components';

const lang = 'en-US';
const translation = translations[lang].QUERY_BUILDER;

export const QuerySourceContainer = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [updatedDataSource, setUpdatedDataSource] = useState<string | null>(
    null
  );

  const { isQueryAvailable } = useQueryValidation();

  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const appUpdateDataSource = useCallback(
    (source: string) => {
      dispatch(changeDataSourceRequest(source, true));
      window.dispatchEvent(new CustomEvent('REFRESH_TAXONOMY'));
    },
    [dispatch]
  );

  const onChangeDataSource = useCallback(
    (dataSource: string) => {
      if (!isQueryAvailable) {
        appUpdateDataSource(dataSource);
        return;
      }

      setUpdatedDataSource(dataSource);
      openModal();
    },
    [isQueryAvailable, appUpdateDataSource, openModal]
  );

  const onConfirm = useCallback(() => {
    appUpdateDataSource(updatedDataSource);
    closeModal();
  }, [closeModal, updatedDataSource, appUpdateDataSource]);

  return (
    <div
      className="flex flex-col gap-2 mx-6 pt-4 pb-6"
      style={{
        boxShadow: '0 8px 6px -6px rgba(0, 0, 0, 0.2)',
      }}
    >
      <Text size="small" variant="dark_lighter">
        {translation.QUERY_SOURCE_LABEL}
      </Text>
      <QuerySource onChangeDataSource={onChangeDataSource} />
      <ConfirmDataSourceChangeModal
        isOpen={isModalOpen}
        onConfirm={onConfirm}
        onCancel={closeModal}
      />
    </div>
  );
};
